import { createIcon } from "@chakra-ui/react";

export const NavLogoWhite = createIcon({
  displayName: "NavLogoWhite",
  viewBox: "218 224 1490 604",
  path: (
    <g fill="white">
      <rect x="474.5" y="239" width="92.7" height="588.4" rx="41" ry="41" />
      <rect x="607.7" y="342.9" width="75.7" height="379.7" rx="37.9" ry="37.9" />
      <rect x="358.3" y="342.9" width="75.7" height="379.7" rx="37.9" ry="37.9" />
      <rect x="233.6" y="411.2" width="75.7" height="245.1" rx="37.9" ry="37.9" />
      <rect x="732.4" y="411.2" width="75.7" height="245.1" rx="37.9" ry="37.9" />
      <path d="M1527.3,459.2l-.2-114.2h-59.2c-6.6.1-37.1,2.1-42.1,29v85.2h-.3v257.2h102v-257.2h-.1Z" />
      <path d="M955.4,459.2l-.2-114.2h-59.1c-6.6.1-37.1,2.1-42.2,29v85.2h-.3v257.2h102v-257.2h-.2Z" />
      <path d="M1383,344.3h-90.6c-31.9,3-52,44-65.9,59.2,0,0,0,0,0,.1l-39.6,53.8-53.6-76c-12.5-16.9-28.6-35.2-49.8-37.1h-89.2l137.5,185.7-136.1,186.4h88.3c23-2.5,39.7-24.6,52.5-42.3l50.4-76.5,39.5,59.4c0,0,.1.2.2.2,13.5,16.2,33.6,55.8,65.2,59.2h88.4l-135.5-183.6,138.3-188.6Z" />
      <g>
        <polygon points="1563.1 355.1 1582.8 355.1 1582.8 402.6 1592.7 402.6 1592.7 355.1 1612.3 355.1 1612.3 345.2 1563.1 345.2 1563.1 355.1" />
        <polygon points="1683.3 345.1 1673.1 345.1 1655.6 387.6 1638.6 345.1 1628.5 345.1 1624 402.6 1634.3 402.6 1637.2 366.4 1652.1 402.6 1659.4 402.6 1674.3 366.4 1676.5 402.6 1687.2 402.6 1683.3 345.1" />
      </g>
    </g>
  )
});
